import ForbiddenNotManager from '@/views/forbidden/ForbiddenNotManager.vue';
import { FORBIDDEN } from '@/helpers/rights';
const ForbiddenRoutes = [
    {
        path: '/forbidden/not-manager',
        name: ForbiddenNotManager.name,
        component: ForbiddenNotManager,
        meta: {
            showAppHeader: true,
            pageType: FORBIDDEN,
        },
    },
];
export default ForbiddenRoutes;
